//#region src/utils/sampling.ts
function clampSamplingRate(samplingRate) {
	return Math.min(1, Math.max(0, samplingRate));
}
//#endregion
export { clampSamplingRate };

//# sourceMappingURL=sampling.js.map